import React from "react";

import { Redirect, Route } from "react-router-dom";

import { ReactLazyImportWithGuard as lazy } from "@lib/lazy-import-with-guard";
import { getCurrentCulture, isNullOrWhitespace } from "@utils";
import { DefaultPath } from "@utils/common/defaultRoutePathsEnum";

const loadFailPath = `/${getCurrentCulture()}/app-update`;
// prettier-ignore
const Error404 = lazy(loadFailPath, ()=>import("@components/error404/Error404"));
// prettier-ignore
const  LegacyRedirects = lazy(loadFailPath, ()=>import("./LegacyRedirects"));

//#region lazy

export function NoMatchRoute(props: { full?: boolean }) {
	const path404 = window.location.pathname + window.location.search;
	return (
		<Route path="*">
			{/* legacy mvc routes */}
			<Route
				path="/:culture/Membership/Authentication/Login"
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/auth/login`} />
				)}
			/>
			<Route
				path="/:culture/Membership/Authentication/ForgotUsername"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/auth/forgot-username`}
					/>
				)}
			/>
			<Route
				path="/:culture/Membership/Password/ForgotPassword"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/auth/forgot-password`}
					/>
				)}
			/>
			<Route
				path="/:culture/Administration/AccountSettings"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/account-settings/personal-data`}
					/>
				)}
			/>
			<Route
				path="/:culture/Administration/AccountSettings/EmailActivation"
				render={({ match }) => (
					<Redirect
						// @ts-expect-error TODO
						to={`/${match.params.culture}/email-activation?${match.params.search}`}
					/>
				)}
			/>
			{/* REDESIGN RE-ROUTING  */}
			<Route
				path="/:culture/home/:period/promo/top-tournament/:topTournamentId"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/sports/full/promo/${match.params.topTournamentId}`}
					/>
				)}
			/>
			<Route
				path="/:culture/home/:period/promo/top-tournament/event/:eventId"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/sports/full/event/${match.params.eventId}`}
					/>
				)}
			/>

			<Route
				path="/:culture/home/:period/top-live/event/:eventId"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/${DefaultPath.LIVE}/${match.params.eventId}`}
					/>
				)}
			/>
			<Route
				path="/:culture/sports/:period/:sport"
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/sports/full`} />
				)}
			/>
			<Route
				path="/:culture/sports/:period/:sport/:segments*"
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/sports/full`} />
				)}
			/>

			<Route
				path="/:culture/search/:period/:searchTerm/:soccer*"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/search/${match.params.period}/${match.params.searchTerm}`}
					/>
				)}
			/>

			<Route
				path="/:culture/search/:period/event/:eventIds"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/sports/${match.params.period}/event/${match.params.eventIds}`}
					/>
				)}
			/>

			<Route
				path="/:culture/bets"
				render={({ match }) => (
					<Redirect to={`/${match.params.culture}/my-bets`} />
				)}
			/>
			<Route
				path="/:culture/live/events"
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/${DefaultPath.LIVE}`}
					/>
				)}
			/>
			<Route
				exact
				path={[
					"/:culture/live/matches/event/:eventIds",
					"/:culture/live/upcoming/event/:eventIds",
					"/:culture/live/highlights/event/:eventIds",
					"/:culture/live/live-stream/event/:eventIds",
					"/:culture/live/my-favorites/event/:eventIds",
					"/:culture/live/played-events/event/:eventIds",
				]}
				render={({ match }) => (
					<Redirect
						to={`/${match.params.culture}/${DefaultPath.LIVE}/${match.params.eventIds}`}
					/>
				)}
			/>
			<LegacyRedirects />

			{/* fallback */}
			{/* if hash exists do not go to fallback because when hash exists path is "/" */}
			{isNullOrWhitespace(window.location.hash) && (
				<Route exact path="/">
					<Redirect
						to={`/${getCurrentCulture()}/${DefaultPath.HOME}`}
					/>
				</Route>
			)}

			{(window.location.pathname == "/" ||
				isNullOrWhitespace(window.location.pathname)) && (
				<Route>
					<Redirect
						to={`/${getCurrentCulture()}/${DefaultPath.HOME}${
							window.location.search
						}`}
					/>
				</Route>
			)}

			<Error404 {...props} path404={path404} />
		</Route>
	);
}
